var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "contract-special-apply" },
    [
      _c("h3", [_vm._v("特殊申请")]),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { "margin-bottom": "20px", "text-align": "right" } },
        [
          _vm.editable &&
          _vm.$parent.checkPer(["admin", "contracts:specialApplyAdd"])
            ? _c(
                "el-dropdown",
                {
                  attrs: { trigger: "click" },
                  on: { command: _vm.handleDropdownCommand },
                },
                [
                  _c("el-button", { attrs: { type: "primary" } }, [
                    _vm._v("\n        添加申请 "),
                    _c("i", { staticClass: "el-icon-arrow-down" }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-dropdown-menu",
                    { attrs: { slot: "dropdown" }, slot: "dropdown" },
                    [
                      _c(
                        "el-dropdown-item",
                        { attrs: { command: "特殊申请" } },
                        [_vm._v("特殊工艺申请")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-dropdown-item",
                        { attrs: { command: "加急申请" } },
                        [_vm._v("加急申请")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-dropdown-item",
                        { attrs: { command: "结案申请" } },
                        [_vm._v("结案申请")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-dropdown-item",
                        { attrs: { command: "报价确认申请" } },
                        [_vm._v("报价确认申请")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.specialApplyList.length > 0
        ? _c(
            "div",
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.specialApplyList, border: "" },
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "applyType", label: "申请类型" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "title", label: "申请标题" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "applyStatus", label: "审核状态" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.applyStatus === "待审批"
                                ? _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        color: "#E6A23C",
                                        "font-weight": "bold",
                                      },
                                    },
                                    [_vm._v(_vm._s(scope.row.applyStatus))]
                                  )
                                : scope.row.applyStatus === "已审批"
                                ? _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        color: "#67C23A",
                                        "font-weight": "bold",
                                      },
                                    },
                                    [_vm._v(_vm._s(scope.row.applyStatus))]
                                  )
                                : _c("span", [
                                    _vm._v(_vm._s(scope.row.applyStatus)),
                                  ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2728265955
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "createTime", label: "创建时间" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "createUserName", label: "申请人" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "操作" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "mini" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.showApplyDetail(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("详情")]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      794735031
                    ),
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "no-data" },
            [_c("el-empty", { attrs: { description: "暂无特殊申请记录" } })],
            1
          ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "申请详情",
            visible: _vm.showDetailDialog,
            width: "800px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showDetailDialog = $event
            },
          },
        },
        [
          _vm.currentApplyDetail
            ? _c(
                "div",
                { staticClass: "apply-detail" },
                [
                  _c("div", { staticClass: "detail-section" }, [
                    _c("h3", [_vm._v("基本信息")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "info-grid" }, [
                      _c("div", { staticClass: "info-item" }, [
                        _c("label", [_vm._v("申请类型：")]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.currentApplyDetail.applyType)),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("label", [_vm._v("审批状态：")]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.currentApplyDetail.applyStatus)),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("label", [_vm._v("合同ID：")]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.currentApplyDetail.contractId)),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("label", [_vm._v("合同编号：")]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.currentApplyDetail.contractNo)),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm.currentApplyDetail.applyType === "加急申请"
                        ? _c("div", { staticClass: "info-item" }, [
                            _c("label", [_vm._v("合同状态：")]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.currentApplyDetail.contractStatus)
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("label", [_vm._v("申请人：")]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.currentApplyDetail.createUserName)),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("label", [_vm._v("创建时间：")]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.currentApplyDetail.createTime)),
                        ]),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm.currentApplyDetail.applyType === "特殊申请"
                    ? [
                        _c("div", { staticClass: "detail-section" }, [
                          _c("h3", [_vm._v("申请详情")]),
                          _vm._v(" "),
                          _c("div", { staticClass: "info-grid" }, [
                            _c("div", { staticClass: "info-item full-width" }, [
                              _c("label", [_vm._v("申请明细：")]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.currentApplyDetail.applicationDetails
                                  )
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "info-item full-width" }, [
                              _c("label", [_vm._v("明细描述：")]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.currentApplyDetail.detailedDescription
                                  )
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "info-item" }, [
                              _c("label", [_vm._v("是否签订回执后购买物料：")]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.currentApplyDetail.isMaterial)
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "info-item" }, [
                              _c("label", [_vm._v("是否需要打样：")]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.currentApplyDetail.isProofing)
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "info-item full-width" }, [
                              _c("label", [_vm._v("客户地址：")]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.currentApplyDetail.custAddress)
                                ),
                              ]),
                            ]),
                          ]),
                        ]),
                      ]
                    : _vm.currentApplyDetail.applyType === "加急申请"
                    ? [
                        _c("div", { staticClass: "detail-section" }, [
                          _c("h3", [_vm._v("客户信息")]),
                          _vm._v(" "),
                          _c("div", { staticClass: "info-grid" }, [
                            _c("div", { staticClass: "info-item" }, [
                              _c("label", [_vm._v("客户姓名：")]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.currentApplyDetail.custName)),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "info-item" }, [
                              _c("label", [_vm._v("客户地址：")]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.currentApplyDetail.custAddress)
                                ),
                              ]),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "detail-section" }, [
                          _c("h3", [_vm._v("申请详情")]),
                          _vm._v(" "),
                          _c("div", { staticClass: "info-grid" }, [
                            false
                              ? _c("div", { staticClass: "info-item" }, [
                                  _c("label", [_vm._v("销售单号：")]),
                                  _vm._v(" "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.formatOrderNos(
                                          _vm.currentApplyDetail.productionOrder
                                        )
                                      ),
                                    },
                                  }),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "info-item" }, [
                              _c("label", [_vm._v("申请日期：")]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatDate(
                                      _vm.currentApplyDetail.applyDate
                                    )
                                  )
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "info-item" }, [
                              _c("label", [_vm._v("申请原因：")]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.currentApplyDetail.applyReason)
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _vm.currentApplyDetail.remark
                              ? _c("div", { staticClass: "info-item" }, [
                                  _c("label", [_vm._v("备注：")]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.currentApplyDetail.remark)
                                    ),
                                  ]),
                                ])
                              : _vm._e(),
                          ]),
                        ]),
                      ]
                    : _vm.currentApplyDetail.applyType === "结案申请"
                    ? [
                        _c("div", { staticClass: "detail-section" }, [
                          _c("h3", [_vm._v("客户信息")]),
                          _vm._v(" "),
                          _c("div", { staticClass: "info-grid" }, [
                            _c("div", { staticClass: "info-item" }, [
                              _c("label", [_vm._v("客户姓名：")]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.currentApplyDetail.custName)),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "info-item" }, [
                              _c("label", [_vm._v("客户地址：")]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.currentApplyDetail.custAddress)
                                ),
                              ]),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "detail-section" }, [
                          _c("h3", [_vm._v("申请详情")]),
                          _vm._v(" "),
                          _c("div", { staticClass: "info-grid" }, [
                            _c("div", { staticClass: "info-item" }, [
                              _c("label", [_vm._v("销售单号：")]),
                              _vm._v(" "),
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.formatOrderNos(
                                      _vm.currentApplyDetail.productionOrder
                                    )
                                  ),
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "info-item" }, [
                              _c("label", [_vm._v("下单日期：")]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatDate(
                                      _vm.currentApplyDetail.orderDate
                                    )
                                  )
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "info-item" }, [
                              _c("label", [_vm._v("拆单日期：")]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatDate(
                                      _vm.currentApplyDetail.orderApprovalDate
                                    )
                                  )
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "info-item" }, [
                              _c("label", [_vm._v("计划交货日期：")]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatDate(
                                      _vm.currentApplyDetail.plannedDeliveryDate
                                    )
                                  )
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "info-item" }, [
                              _c("label", [_vm._v("申请日期：")]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatDate(
                                      _vm.currentApplyDetail.applyDate
                                    )
                                  )
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "info-item" }, [
                              _c("label", [_vm._v("申请原因：")]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.currentApplyDetail.applyReason)
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "info-item" }, [
                              _c("label", [
                                _vm._v("取消后重新下单是否需要加急："),
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.currentApplyDetail.urgentAfterReorder
                                  )
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _vm.currentApplyDetail.remark
                              ? _c("div", { staticClass: "info-item" }, [
                                  _c("label", [_vm._v("备注：")]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.currentApplyDetail.remark)
                                    ),
                                  ]),
                                ])
                              : _vm._e(),
                          ]),
                        ]),
                      ]
                    : _vm.currentApplyDetail.applyType === "报价确认申请"
                    ? [
                        _c("div", { staticClass: "detail-section" }, [
                          _c("h3", [_vm._v("客户信息")]),
                          _vm._v(" "),
                          _c("div", { staticClass: "info-grid" }, [
                            _c("div", { staticClass: "info-item" }, [
                              _c("label", [_vm._v("客户姓名：")]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.currentApplyDetail.custName)),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "info-item" }, [
                              _c("label", [_vm._v("客户地址：")]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.currentApplyDetail.custAddress)
                                ),
                              ]),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "detail-section" }, [
                          _c("h3", [_vm._v("申请详情")]),
                          _vm._v(" "),
                          _c("div", { staticClass: "info-grid" }, [
                            _c("div", { staticClass: "info-item" }, [
                              _c("label", [_vm._v("销售单号：")]),
                              _vm._v(" "),
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.formatOrderNos(
                                      _vm.currentApplyDetail.productionOrder
                                    )
                                  ),
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "info-item" }, [
                              _c("label", [_vm._v("付款事由：")]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.currentApplyDetail.payReason)
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _vm.$parent.checkPer([
                              "admin",
                              "contracts:quotation",
                            ])
                              ? _c("div", { staticClass: "info-item" }, [
                                  _c("label", [_vm._v("总金额：")]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.currentApplyDetail.totalAmount)
                                    ),
                                  ]),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "info-item" }, [
                              _c("label", [_vm._v("收款账户：")]),
                              _vm._v(" "),
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.formatAccount(
                                      _vm.currentApplyDetail.receivingAccount
                                    )
                                  ),
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _vm.currentApplyDetail.remark
                              ? _c("div", { staticClass: "info-item" }, [
                                  _c("label", [_vm._v("备注：")]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.currentApplyDetail.remark)
                                    ),
                                  ]),
                                ])
                              : _vm._e(),
                          ]),
                        ]),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentApplyDetail.file
                    ? _c("div", { staticClass: "detail-section" }, [
                        _c("h3", [_vm._v("附件")]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "file-list" },
                          _vm._l(
                            _vm.parseSpecialApplyFile(
                              _vm.currentApplyDetail.file
                            ),
                            function (file, index) {
                              return _c(
                                "div",
                                {
                                  key: index,
                                  staticClass: "file-item",
                                  staticStyle: {
                                    float: "left",
                                    "margin-right": "10px",
                                    "text-align": "center",
                                    position: "relative",
                                  },
                                  style: {
                                    cursor:
                                      file.type !== "图片"
                                        ? "pointer"
                                        : "default",
                                  },
                                  on: {
                                    click: function ($event) {
                                      file.type !== "图片"
                                        ? _vm.downloadFile(file.url)
                                        : null
                                    },
                                  },
                                },
                                [
                                  file.type === "图片"
                                    ? [
                                        _c("el-image", {
                                          staticStyle: {
                                            width: "100px",
                                            height: "100px",
                                            "border-radius": "5px",
                                          },
                                          attrs: {
                                            src: file.url,
                                            "preview-src-list": [file.url],
                                          },
                                        }),
                                      ]
                                    : [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              height: "100px",
                                              width: "100px",
                                              "border-radius": "5px",
                                              "background-color": "#f5f7fa",
                                              display: "flex",
                                              "align-items": "center",
                                              "justify-content": "center",
                                              border: "1px solid #ebeef5",
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  "text-align": "center",
                                                  padding: "10px",
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-document",
                                                  staticStyle: {
                                                    "font-size": "32px",
                                                    color: "#909399",
                                                    "margin-bottom": "5px",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      "word-break": "break-all",
                                                      "max-width": "80px",
                                                      "font-size": "12px",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(file.realName)
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ],
                                ],
                                2
                              )
                            }
                          ),
                          0
                        ),
                      ])
                    : _vm._e(),
                ],
                2
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.isEditMode
              ? "编辑" + _vm.specialApplyForm.applyType
              : "添加" + _vm.specialApplyForm.applyType,
            visible: _vm.showSpecialApplyDialog,
            width: "600px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showSpecialApplyDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.specialApplyForm, "label-width": "130px" } },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "contractNo" } },
                [
                  _c("template", { slot: "label" }, [
                    _vm._v("\n          合同号\n        "),
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    staticStyle: { width: "100%" },
                    attrs: { placeholder: "请输入合同号", disabled: "" },
                    model: {
                      value: _vm.specialApplyForm.contractNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.specialApplyForm, "contractNo", $$v)
                      },
                      expression: "specialApplyForm.contractNo",
                    },
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _vm.specialApplyForm.applyType !== "特殊申请"
                ? _c(
                    "el-form-item",
                    { attrs: { prop: "orderNo" } },
                    [
                      _c("template", { slot: "label" }, [
                        _c("span", { staticStyle: { color: "red" } }, [
                          _vm._v("*"),
                        ]),
                        _vm._v(" 销售单号\n        "),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            multiple: "",
                            placeholder: "请选择销售单号",
                          },
                          on: { change: _vm.handleOrderChange },
                          model: {
                            value: _vm.specialApplyForm.orderNo,
                            callback: function ($$v) {
                              _vm.$set(_vm.specialApplyForm, "orderNo", $$v)
                            },
                            expression: "specialApplyForm.orderNo",
                          },
                        },
                        _vm._l(_vm.contractOrders, function (order) {
                          return _c(
                            "el-option",
                            {
                              key: order.productionOrder,
                              attrs: {
                                label: order.productionOrder,
                                value: order.productionOrder,
                              },
                            },
                            [
                              _vm.specialApplyForm.applyType === "报价确认申请"
                                ? _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "justify-content": "space-between",
                                      },
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(_vm._s(order.productionOrder)),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticStyle: { color: "#999" } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              order.totalPrice
                                                ? "金额: " + order.totalPrice
                                                : ""
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _c("div", [
                                    _c("span", [
                                      _vm._v(_vm._s(order.productionOrder)),
                                    ]),
                                  ]),
                            ]
                          )
                        }),
                        1
                      ),
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.specialApplyForm.applyType === "加急申请"
                ? [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "custName" } },
                      [
                        _c("template", { slot: "label" }, [
                          _c("span", { staticStyle: { color: "red" } }, [
                            _vm._v("*"),
                          ]),
                          _vm._v(" 客户姓名\n          "),
                        ]),
                        _vm._v(" "),
                        _c("el-input", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: "请输入客户姓名",
                            disabled: "",
                          },
                          model: {
                            value: _vm.specialApplyForm.custName,
                            callback: function ($$v) {
                              _vm.$set(_vm.specialApplyForm, "custName", $$v)
                            },
                            expression: "specialApplyForm.custName",
                          },
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { prop: "custAddress" } },
                      [
                        _c("template", { slot: "label" }, [
                          _c("span", { staticStyle: { color: "red" } }, [
                            _vm._v("*"),
                          ]),
                          _vm._v(" 客户地址\n          "),
                        ]),
                        _vm._v(" "),
                        _c("el-input", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: "请输入客户地址",
                            disabled: "",
                          },
                          model: {
                            value: _vm.specialApplyForm.custAddress,
                            callback: function ($$v) {
                              _vm.$set(_vm.specialApplyForm, "custAddress", $$v)
                            },
                            expression: "specialApplyForm.custAddress",
                          },
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { prop: "applyDate" } },
                      [
                        _c("template", { slot: "label" }, [
                          _c("span", { staticStyle: { color: "red" } }, [
                            _vm._v("*"),
                          ]),
                          _vm._v(" 申请日期\n          "),
                        ]),
                        _vm._v(" "),
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            type: "date",
                            placeholder: "请选择申请日期",
                            "value-format": "yyyy-MM-dd",
                          },
                          model: {
                            value: _vm.specialApplyForm.applyDate,
                            callback: function ($$v) {
                              _vm.$set(_vm.specialApplyForm, "applyDate", $$v)
                            },
                            expression: "specialApplyForm.applyDate",
                          },
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { prop: "applyReason" } },
                      [
                        _c("template", { slot: "label" }, [
                          _c("span", { staticStyle: { color: "red" } }, [
                            _vm._v("*"),
                          ]),
                          _vm._v(" 申请原因\n          "),
                        ]),
                        _vm._v(" "),
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            rows: "4",
                            placeholder: "请输入申请原因",
                          },
                          model: {
                            value: _vm.specialApplyForm.applyReason,
                            callback: function ($$v) {
                              _vm.$set(_vm.specialApplyForm, "applyReason", $$v)
                            },
                            expression: "specialApplyForm.applyReason",
                          },
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { prop: "remark" } },
                      [
                        _c("template", { slot: "label" }, [
                          _vm._v("\n            备注\n          "),
                        ]),
                        _vm._v(" "),
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            rows: "2",
                            placeholder: "请输入备注",
                          },
                          model: {
                            value: _vm.specialApplyForm.remark,
                            callback: function ($$v) {
                              _vm.$set(_vm.specialApplyForm, "remark", $$v)
                            },
                            expression: "specialApplyForm.remark",
                          },
                        }),
                      ],
                      2
                    ),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.specialApplyForm.applyType === "特殊申请"
                ? [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "custName" } },
                      [
                        _c("template", { slot: "label" }, [
                          _c("span", { staticStyle: { color: "red" } }, [
                            _vm._v("*"),
                          ]),
                          _vm._v(" 客户姓名\n          "),
                        ]),
                        _vm._v(" "),
                        _c("el-input", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: "请输入客户姓名",
                            disabled: "",
                          },
                          model: {
                            value: _vm.specialApplyForm.custName,
                            callback: function ($$v) {
                              _vm.$set(_vm.specialApplyForm, "custName", $$v)
                            },
                            expression: "specialApplyForm.custName",
                          },
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { prop: "title" } },
                      [
                        _c("template", { slot: "label" }, [
                          _c("span", { staticStyle: { color: "red" } }, [
                            _vm._v("*"),
                          ]),
                          _vm._v(" 申请标题\n          "),
                        ]),
                        _vm._v(" "),
                        _c("el-input", {
                          staticStyle: { width: "100%" },
                          attrs: { placeholder: "请输入申请标题" },
                          model: {
                            value: _vm.specialApplyForm.title,
                            callback: function ($$v) {
                              _vm.$set(_vm.specialApplyForm, "title", $$v)
                            },
                            expression: "specialApplyForm.title",
                          },
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { prop: "applicationDetails" } },
                      [
                        _c("template", { slot: "label" }, [
                          _c("span", { staticStyle: { color: "red" } }, [
                            _vm._v("*"),
                          ]),
                          _vm._v(" 申请明细\n          "),
                        ]),
                        _vm._v(" "),
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            rows: "4",
                            placeholder: "请输入申请明细",
                          },
                          model: {
                            value: _vm.specialApplyForm.applicationDetails,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.specialApplyForm,
                                "applicationDetails",
                                $$v
                              )
                            },
                            expression: "specialApplyForm.applicationDetails",
                          },
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { prop: "detailedDescription" } },
                      [
                        _c("template", { slot: "label" }, [
                          _c("span", { staticStyle: { color: "red" } }, [
                            _vm._v("*"),
                          ]),
                          _vm._v(" 明细描述\n          "),
                        ]),
                        _vm._v(" "),
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            rows: "4",
                            placeholder: "请输入明细描述",
                          },
                          model: {
                            value: _vm.specialApplyForm.detailedDescription,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.specialApplyForm,
                                "detailedDescription",
                                $$v
                              )
                            },
                            expression: "specialApplyForm.detailedDescription",
                          },
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { prop: "isMaterial" } },
                      [
                        _c("template", { slot: "label" }, [
                          _c("span", { staticStyle: { color: "red" } }, [
                            _vm._v("*"),
                          ]),
                          _vm._v(" 是否在签订回执后购买物料\n          "),
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: { placeholder: "请选择" },
                            model: {
                              value: _vm.specialApplyForm.isMaterial,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.specialApplyForm,
                                  "isMaterial",
                                  $$v
                                )
                              },
                              expression: "specialApplyForm.isMaterial",
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "是", value: "是" },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "否", value: "否" },
                            }),
                          ],
                          1
                        ),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { prop: "isProofing" } },
                      [
                        _c("template", { slot: "label" }, [
                          _c("span", { staticStyle: { color: "red" } }, [
                            _vm._v("*"),
                          ]),
                          _vm._v(" 是否需要打样\n          "),
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: { placeholder: "请选择" },
                            model: {
                              value: _vm.specialApplyForm.isProofing,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.specialApplyForm,
                                  "isProofing",
                                  $$v
                                )
                              },
                              expression: "specialApplyForm.isProofing",
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "是", value: "是" },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "否", value: "否" },
                            }),
                          ],
                          1
                        ),
                      ],
                      2
                    ),
                  ]
                : _vm.specialApplyForm.applyType === "结案申请"
                ? [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "custName" } },
                      [
                        _c("template", { slot: "label" }, [
                          _c("span", { staticStyle: { color: "red" } }, [
                            _vm._v("*"),
                          ]),
                          _vm._v(" 客户名称\n          "),
                        ]),
                        _vm._v(" "),
                        _c("el-input", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: "请输入客户名称",
                            disabled: "",
                          },
                          model: {
                            value: _vm.specialApplyForm.custName,
                            callback: function ($$v) {
                              _vm.$set(_vm.specialApplyForm, "custName", $$v)
                            },
                            expression: "specialApplyForm.custName",
                          },
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { prop: "custAddress" } },
                      [
                        _c("template", { slot: "label" }, [
                          _c("span", { staticStyle: { color: "red" } }, [
                            _vm._v("*"),
                          ]),
                          _vm._v(" 客户地址\n          "),
                        ]),
                        _vm._v(" "),
                        _c("el-input", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: "请输入客户地址",
                            disabled: "",
                          },
                          model: {
                            value: _vm.specialApplyForm.custAddress,
                            callback: function ($$v) {
                              _vm.$set(_vm.specialApplyForm, "custAddress", $$v)
                            },
                            expression: "specialApplyForm.custAddress",
                          },
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { prop: "orderDate" } },
                      [
                        _c("template", { slot: "label" }, [
                          _c("span", { staticStyle: { color: "red" } }, [
                            _vm._v("*"),
                          ]),
                          _vm._v(" 下单日期\n          "),
                        ]),
                        _vm._v(" "),
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            type: "date",
                            placeholder: "请选择下单日期",
                            "value-format": "yyyy-MM-dd",
                          },
                          model: {
                            value: _vm.specialApplyForm.orderDate,
                            callback: function ($$v) {
                              _vm.$set(_vm.specialApplyForm, "orderDate", $$v)
                            },
                            expression: "specialApplyForm.orderDate",
                          },
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { prop: "orderApprovalDate" } },
                      [
                        _c("template", { slot: "label" }, [
                          _vm._v("\n            拆单日期\n          "),
                        ]),
                        _vm._v(" "),
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            type: "date",
                            placeholder: "请选择拆单日期",
                            "value-format": "yyyy-MM-dd",
                          },
                          model: {
                            value: _vm.specialApplyForm.orderApprovalDate,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.specialApplyForm,
                                "orderApprovalDate",
                                $$v
                              )
                            },
                            expression: "specialApplyForm.orderApprovalDate",
                          },
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { prop: "plannedDeliveryDate" } },
                      [
                        _c("template", { slot: "label" }, [
                          _vm._v("\n            计划交货日期\n          "),
                        ]),
                        _vm._v(" "),
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            type: "date",
                            placeholder: "请选择计划交货日期",
                            "value-format": "yyyy-MM-dd",
                          },
                          model: {
                            value: _vm.specialApplyForm.plannedDeliveryDate,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.specialApplyForm,
                                "plannedDeliveryDate",
                                $$v
                              )
                            },
                            expression: "specialApplyForm.plannedDeliveryDate",
                          },
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { prop: "applyDate" } },
                      [
                        _c("template", { slot: "label" }, [
                          _c("span", { staticStyle: { color: "red" } }, [
                            _vm._v("*"),
                          ]),
                          _vm._v(" 申请日期\n          "),
                        ]),
                        _vm._v(" "),
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            type: "date",
                            placeholder: "请选择申请日期",
                            "value-format": "yyyy-MM-dd",
                          },
                          model: {
                            value: _vm.specialApplyForm.applyDate,
                            callback: function ($$v) {
                              _vm.$set(_vm.specialApplyForm, "applyDate", $$v)
                            },
                            expression: "specialApplyForm.applyDate",
                          },
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { prop: "applyReason" } },
                      [
                        _c("template", { slot: "label" }, [
                          _c("span", { staticStyle: { color: "red" } }, [
                            _vm._v("*"),
                          ]),
                          _vm._v(" 申请原因\n          "),
                        ]),
                        _vm._v(" "),
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            rows: "4",
                            placeholder: "请输入申请原因",
                          },
                          model: {
                            value: _vm.specialApplyForm.applyReason,
                            callback: function ($$v) {
                              _vm.$set(_vm.specialApplyForm, "applyReason", $$v)
                            },
                            expression: "specialApplyForm.applyReason",
                          },
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { prop: "urgentAfterReorder" } },
                      [
                        _c("template", { slot: "label" }, [
                          _c("span", { staticStyle: { color: "red" } }, [
                            _vm._v("*"),
                          ]),
                          _vm._v(" 取消后重新下单是否需要加急\n          "),
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: { placeholder: "请选择" },
                            model: {
                              value: _vm.specialApplyForm.urgentAfterReorder,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.specialApplyForm,
                                  "urgentAfterReorder",
                                  $$v
                                )
                              },
                              expression: "specialApplyForm.urgentAfterReorder",
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "是", value: "是" },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "否", value: "否" },
                            }),
                          ],
                          1
                        ),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { prop: "remark" } },
                      [
                        _c("template", { slot: "label" }, [
                          _vm._v("\n            备注\n          "),
                        ]),
                        _vm._v(" "),
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            rows: "2",
                            placeholder: "请输入备注",
                          },
                          model: {
                            value: _vm.specialApplyForm.remark,
                            callback: function ($$v) {
                              _vm.$set(_vm.specialApplyForm, "remark", $$v)
                            },
                            expression: "specialApplyForm.remark",
                          },
                        }),
                      ],
                      2
                    ),
                  ]
                : _vm.specialApplyForm.applyType === "报价确认申请"
                ? [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "custName" } },
                      [
                        _c("template", { slot: "label" }, [
                          _vm._v("\n            客户姓名\n          "),
                        ]),
                        _vm._v(" "),
                        _c("el-input", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: "请输入客户姓名",
                            disabled: "",
                          },
                          model: {
                            value: _vm.specialApplyForm.custName,
                            callback: function ($$v) {
                              _vm.$set(_vm.specialApplyForm, "custName", $$v)
                            },
                            expression: "specialApplyForm.custName",
                          },
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { prop: "custAddress" } },
                      [
                        _c("template", { slot: "label" }, [
                          _vm._v("\n            客户地址\n          "),
                        ]),
                        _vm._v(" "),
                        _c("el-input", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: "请输入客户地址",
                            disabled: "",
                          },
                          model: {
                            value: _vm.specialApplyForm.custAddress,
                            callback: function ($$v) {
                              _vm.$set(_vm.specialApplyForm, "custAddress", $$v)
                            },
                            expression: "specialApplyForm.custAddress",
                          },
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { prop: "payReason" } },
                      [
                        _c("template", { slot: "label" }, [
                          _c("span", { staticStyle: { color: "red" } }, [
                            _vm._v("*"),
                          ]),
                          _vm._v(" 付款事由\n          "),
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: "请选择付款事由",
                              "popper-class": "multi-line-select",
                            },
                            model: {
                              value: _vm.specialApplyForm.payReason,
                              callback: function ($$v) {
                                _vm.$set(_vm.specialApplyForm, "payReason", $$v)
                              },
                              expression: "specialApplyForm.payReason",
                            },
                          },
                          _vm._l(
                            _vm.dict.order_payment_reason.filter(function (i) {
                              return i.unit === "true"
                            }),
                            function (item) {
                              return _c(
                                "el-option",
                                {
                                  key: item.id,
                                  attrs: {
                                    label: item.label,
                                    value: item.value,
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "multi-line-option" },
                                    _vm._l(
                                      item.label.split("|"),
                                      function (sub, index) {
                                        return _c(
                                          "span",
                                          {
                                            key: index,
                                            staticClass: "option-line",
                                          },
                                          [_vm._v(_vm._s(sub.trim()))]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              )
                            }
                          ),
                          1
                        ),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _vm.$parent.checkPer(["admin", "contracts:quotation"])
                      ? _c(
                          "el-form-item",
                          { attrs: { prop: "totalAmount" } },
                          [
                            _c("template", { slot: "label" }, [
                              _c("span", { staticStyle: { color: "red" } }, [
                                _vm._v("*"),
                              ]),
                              _vm._v(" 总金额\n          "),
                            ]),
                            _vm._v(" "),
                            _c("el-input-number", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: "请输入总金额",
                                min: 0,
                                precision: 2,
                              },
                              model: {
                                value: _vm.specialApplyForm.totalAmount,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.specialApplyForm,
                                    "totalAmount",
                                    $$v
                                  )
                                },
                                expression: "specialApplyForm.totalAmount",
                              },
                            }),
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { prop: "receivingAccount" } },
                      [
                        _c("template", { slot: "label" }, [
                          _c("span", { staticStyle: { color: "red" } }, [
                            _vm._v("*"),
                          ]),
                          _vm._v(" 收款账户\n          "),
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: "请选择收款账户",
                              "popper-class": "multi-line-select",
                            },
                            model: {
                              value: _vm.specialApplyForm.receivingAccount,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.specialApplyForm,
                                  "receivingAccount",
                                  $$v
                                )
                              },
                              expression: "specialApplyForm.receivingAccount",
                            },
                          },
                          _vm._l(
                            _vm.dict.order_receiving_account.filter(function (
                              i
                            ) {
                              return i.unit === "true"
                            }),
                            function (item) {
                              return _c(
                                "el-option",
                                {
                                  key: item.id,
                                  attrs: {
                                    label: item.label,
                                    value: item.value,
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "multi-line-option" },
                                    _vm._l(
                                      item.label.split("|"),
                                      function (sub, index) {
                                        return _c(
                                          "span",
                                          {
                                            key: index,
                                            staticClass: "option-line",
                                          },
                                          [_vm._v(_vm._s(sub.trim()))]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              )
                            }
                          ),
                          1
                        ),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { prop: "remark" } },
                      [
                        _c("template", { slot: "label" }, [
                          _vm._v("\n            备注\n          "),
                        ]),
                        _vm._v(" "),
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            rows: "4",
                            placeholder: "请输入备注",
                          },
                          model: {
                            value: _vm.specialApplyForm.remark,
                            callback: function ($$v) {
                              _vm.$set(_vm.specialApplyForm, "remark", $$v)
                            },
                            expression: "specialApplyForm.remark",
                          },
                        }),
                      ],
                      2
                    ),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "附件" } },
                [
                  _c("template", { slot: "label" }, [
                    _vm.specialApplyForm.applyType === "报价确认申请" ||
                    _vm.specialApplyForm.applyType === "加急申请"
                      ? _c("span", { staticStyle: { color: "red" } }, [
                          _vm._v("*"),
                        ])
                      : _vm._e(),
                    _vm._v(" 附件\n        "),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c("CommonUpload", {
                        ref: "specialApplyFileUpload",
                        on: {
                          uploadSuccess: _vm.handleFileUpload,
                          delSuccess: _vm.handleFileDelete,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.showSpecialApplyDialog = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.saveSpecialApply },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }